<script>
  let text = "if you've followed this far you must be committed";

  function numone() {
    texty.innerHTML="the map is coming";
  }

  function numtwo() {
    texty.innerHTML="you'll have to find the key yourself";
  }

  function numthr() {
    texty.innerHTML="i can't tell you any more";
  }

  function numfou() {
    texty.innerHTML="but you'll know it when you see it";
  }

  function numfiv() {
    texty.innerHTML="i've said everything i can at this moment";
  }

  function numsix() {
    texty.innerHTML="please";
  }

  function numsev() {
    texty.innerHTML="s̶t̶o̶p̶";
  }

  function numeig() {
    texty.innerHTML=" ";
  }

  function numnin() {
    texty.innerHTML="i'm sorry";
  }

  setTimeout(numone, 2500);
  setTimeout(numtwo, 5000);
  setTimeout(numthr, 7500);
  setTimeout(numfou, 10000);
  setTimeout(numfiv, 12500);
  setTimeout(numsix, 15000);
  setTimeout(numsev, 17500);
  setTimeout(numeig, 20000);
  setTimeout(numnin, 25000);

</script>

<style>
  .bigbox{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: darkred;
    z-index: 11;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: Georgia, 'Times New Roman', Times, serif;
    font-size: 3vw;
    font-style: italic;
  }

  .textbox {
    width: 70%;
    animation: 0.1s smallshake infinite;
  }

  @keyframes smallshake {
    0% { transform: skewX(-0deg); }
    20% { transform: skewX(15deg); }
    23% { transform: skewX(-15deg); }
    25% { transform: skewX(0deg); }
    60% { transform: skewX(0deg); }
    80% { transform: skewX(0deg); }
    100% { transform: skewX(0deg); }
  }
</style>

<div class='bigbox'><div class='textbox' id='texty'>{text}</div></div>
